export default __webpack_public_path__ + "static/media/gallery_02.1fc71f80.jpg";